import type { SVGProps } from 'react';

const SvgMoneyTopUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M19 7.18V6c0-1.65-1.35-3-3-3H6C4.35 3 3 4.35 3 6v3c0 .55.45 1 1 1s1-.45 1-1V6c0-.55.45-1 1-1h10c.55 0 1 .45 1 1v1h-.83c-2.22 0-4.05 1.66-4.17 3.79-.06 1.11.33 2.16 1.09 2.97.75.79 1.81 1.25 2.9 1.25h1v1c0 .55-.45 1-1 1h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c1.65 0 3-1.35 3-3v-1.18c1.16-.41 2-1.51 2-2.82v-2c0-1.3-.84-2.4-2-2.82zM19 12c0 .55-.45 1-1 1h-2c-.55 0-1.07-.22-1.45-.62s-.58-.93-.55-1.49C14.05 9.85 15.03 9 16.17 9H18c.55 0 1 .45 1 1z"
    />
    <path
      fill="currentcolor"
      d="M16.92 10.62a.8.8 0 0 0-.09-.18c-.03-.05-.08-.1-.12-.15q-.15-.135-.33-.21a.96.96 0 0 0-.76 0q-.18.075-.33.21c-.04.05-.09.1-.12.15q-.06.09-.09.18-.045.09-.06.18c0 .07-.02.13-.02.2 0 .06 0 .13.02.19.01.07.03.13.06.19.02.06.05.12.09.17.03.06.08.11.12.16q.15.135.33.21c.12.05.25.08.38.08s.26-.03.38-.08c.13-.05.23-.12.33-.21.04-.05.09-.1.12-.16.04-.05.07-.11.09-.17.03-.06.05-.12.06-.19.01-.06.02-.13.02-.19 0-.07 0-.13-.02-.2 0-.06-.03-.12-.06-.18m-9.21.67a.996.996 0 0 0-1.41 0l-3.01 3A.996.996 0 1 0 4.7 15.7l1.29-1.29V19c0 .55.45 1 1 1s1-.45 1-1v-4.59l1.29 1.29c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41l-3-3z"
    />
  </svg>
);
export default SvgMoneyTopUp;
